import { Component } from '@angular/core';
import {
  PlainButtonComponent,
  PlainIconButtonComponent,
} from '@group24ag/flowkit';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-my-plain-buttons',
  imports: [PlainButtonComponent, PlainIconButtonComponent],
  template: `
    <div>
      <h2 class="heading-title--small">Plain</h2>
      <div class="flex gap-5">
        <button
          flkPlainIconButton
          [icon]="['fas', 'copy']"
          [tooltip]="'Plain'"></button>

        <button
          flkPlainIconButton
          [icon]="['fas', 'copy']"
          [tooltip]="'Magic'"
          [disabled]="true"></button>

        <button
          flkPlainIconButton
          [icon]="['fas', 'copy']"
          [tooltip]="'Plain'"
          [loading]="true"></button>

        <button flkPlainButton>Plain</button>
        <button flkPlainButton [icon]="['fas', 'copy']" iconSize="fa-sm">
          Plain
        </button>

        <button flkPlainButton [disabled]="true">Plain</button>
        <button
          flkPlainButton
          [disabled]="true"
          [icon]="['fas', 'copy']"
          iconSize="fa-sm">
          Plain
        </button>

        <button flkPlainButton [loading]="true">Plain</button>
      </div>
    </div>
  `,
})
export class PlainButtonsComponent {
  constructor(lib: FaIconLibrary) {
    lib.addIcons(faCopy);
  }
}
